import { BigNumber, constants as etherConstants } from 'ethers';
import Web3 from 'web3';

import { CASHIER_PAYMENT_ABI } from 'constants/abi/cashier-payment-abi.constant';
import { NETWORK_SETTINGS } from 'constants/network.constant';

import { BaseWeb3Service } from './base-web3.service';

/**
 * Service for handling cashier/passive income contract interactions
 * Manages passive income withdrawals/voucher payments
 */
export class CashierService extends BaseWeb3Service {
  private readonly cashierPaymentAbi = CASHIER_PAYMENT_ABI;
  private readonly cashierAddress = NETWORK_SETTINGS.CASHIER_HANDLER.ADDRESS;
  private readonly cashierContract: any;

  constructor(web3: Web3, torusProvider?: any) {
    super(web3, torusProvider);
    this.cashierContract = this.createContract(this.cashierPaymentAbi, this.cashierAddress);
  }

  /**
   * Gets the total amount withdrawn by a wallet
   */
  async getWithdrawn(walletAddress: string): Promise<string> {
    return await this.cashierContract.methods.getWithdrawn(walletAddress).call();
  }

  /**
   * Withdraws passive income using a voucher payment signature
   */
  async voucherPayment(walletAddress: string, amount: number, voucherPaymentSignature: string): Promise<any> {
    const amountInWei = BigNumber.from(amount).mul(etherConstants.WeiPerEther);
    const gasPrice = await this.getGasPrice();

    return await this.cashierContract.methods
      .withdraw({ receiver: walletAddress, totalAmount: amountInWei }, voucherPaymentSignature)
      .send({ from: walletAddress, gasPrice });
  }
}
